<template>
  <div class="signregist-container">

    <img src="../../assets/images/login-logo.png" class="login-logo cup" @click="$navigate('/index/index', null, false)"
      alt="">

    <img :src="require('../../assets/images/logintext-' + language + '.png')" class="login-textimg" alt="">

    <div class="signregist-content df fdc">
      <div class="title fn df">
        <span class="active">{{ titleType == 1 ? $t('活动报名') : $t('活动签到') }}</span>
      </div>

      <div class="signregist-box mt-24 mb-16 f1">
        <el-form :model="form" :rules="rules" ref="form" v-loading="loading">
          <!-- 手机报名 / 邮箱报名 单选框 -->
          <div v-if="isLogin == 1">
            <el-form-item prop="register_type" class="type-item">
              <el-radio-group v-model="form.register_type" @change="handleSignTypeChange">
                <el-radio v-model="form.register_type" :label="1">{{ $t('手机报名') }}</el-radio>
                <el-radio v-model="form.register_type" :label="2">{{ $t('邮箱报名') }}</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- 电话区号 + 姓名 -->
            <div class="df">
              <el-form-item prop="user_mobile_area_code" class="form-item" v-if="form.register_type == 1">
                <!-- 下拉选择电话区号 -->
                <span class="iconfont icon-jia1 fs-14 ml-16"></span>
                <el-input v-model="form.user_mobile_area_code" class="areacode-ipt ml-6" style="width: 80px;"
                  :placeholder="$t('区号')"></el-input>
              </el-form-item>
              <el-form-item prop="user_mobile" class="phone-item ml-8 f1" v-if="form.register_type == 1">
                <!-- 验证码 -->
                <el-input v-model="form.user_mobile" :placeholder="$t('请输入手机号')"
                  :disabled="disabledMobileEmail"></el-input>
              </el-form-item>
            </div>


            <!-- 邮箱 -->
            <el-form-item prop="user_email" class="form-item" v-if="form.register_type == 2">
              <el-input v-model="form.user_email" :placeholder="$t('请输入邮箱')" :disabled="disabledMobileEmail"></el-input>
            </el-form-item>

            <el-form-item class="form-item" :prop="isLogin !== 2 ? 'code' : undefined" v-if="form.register_type == 1">
              <div class="df pr-16">
                <el-input v-model="form.code" :placeholder="$t('请输入验证码')" maxlength="8" @blur="handleBlur"
                  :disabled="disabledMobileEmail"></el-input>
                <el-button type="text" @click="getCode" :disabled="showCountdown">
                  {{ showCountdown ? countdown : $t('获取验证码') }}
                </el-button>
              </div>
            </el-form-item>

            <el-form-item :prop="isLogin !== 2 ? 'code' : undefined" class="form-item" v-else>
              <div class="df pr-16">
                <el-input v-model="form.code" :placeholder="$t('请输入验证码')" maxlength="8" @blur="handleBlur"
                  :disabled="disabledMobileEmail"></el-input>
                <el-button type="text" @click="getCode" :disabled="showCountdownEmail">
                  {{ showCountdownEmail ? countdownEmail : $t('获取验证码') }}
                </el-button>
              </div>
            </el-form-item>
          </div>


          <!-- 选择地区 -->
          <el-form-item prop="register_country" class="form-item">
            <el-select v-model="form.register_country" :placeholder="$t('请选择国家/区域')" name="register_country"
              @change="handlerCountry" style="width: 100%;">
              <template>
                <el-option disabled class="search_input">

                  <el-input :placeholder="$t('搜索关键字')" v-model="Searchcountry"
                    @input="dropDownSearchcountry"></el-input>
                  <div v-if="dropDownSearchcountry().length == 0" class="ta-c c-6">{{ $t('暂无数据') }}</div>
                </el-option>
              </template>
              <el-option :label="items.label" :value="items.value" v-for="(items, index) in dropDownSearchcountry()"
                :key="items.value"></el-option>
            </el-select>
          </el-form-item>
          <!-- 选择省份 -->
          <el-form-item prop="register_province" class="form-item" v-if="currentLang=='zh'">
            <el-select v-model="form.register_province" :placeholder="$t('请选择所在省份/州')" name="register_province"
              style="width: 100%;">
              <template>
                <el-option disabled :value="''" class="search_input">
                  <el-input :placeholder="$t('搜索关键字')" v-model="Searchprovince"
                    @input="dropDownSearchprovince"></el-input>
                  <div v-if="dropDownSearchprovince().length == 0" class="ta-c c-6">{{ $t('暂无数据') }}</div>
                </el-option>
              </template>
              <el-option :label="items.label" :value="items.value" v-for="(items, index) in dropDownSearchprovince()"
                :key="items.value"></el-option>
            </el-select>
          </el-form-item>
          <!-- 姓名 -->
          <el-form-item prop="user_name" class="form-item">
            <el-input v-model="form.user_name" :placeholder="$t('请输入姓名')" :disabled="disabledExpert"></el-input>
          </el-form-item>
          <!-- 昵称 -->
          <el-form-item prop="user_nick_name" class="form-item">
            <el-input v-model="form.user_nick_name" :placeholder="$t('请输入昵称')"></el-input>
          </el-form-item>
          <!-- 公司名称 -->
          <el-form-item prop="user_company" class="form-item">
            <el-input v-model="form.user_company" :placeholder="$t('请输入公司名称')"></el-input>
          </el-form-item>
          <!-- 选择行业 -->
          <el-form-item prop="user_industry" class="form-item">
            <el-select v-model="form.user_industry" :placeholder="$t('请选择行业')" style="width: 100%;">
              <el-option :label="items.label" :value="items.value" v-for="(items, index) in industryList"
                :key="items.value"></el-option>
            </el-select>
          </el-form-item>
          <!-- 选择职位 -->
          <el-form-item prop="user_job" class="form-item">
            <el-select v-model="form.user_job" :placeholder="$t('请选择职位')" style="width: 100%;">
              <el-option :label="items.label" :value="items.value" v-for="(items, index) in jobList"
                :key="items.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="user_role" class="form-item">
            <el-select v-model="form.user_role" :placeholder="$t('请选择角色')" style="width: 100%;" multiple>
              <el-option v-for="item in roleList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 邮箱 -->
          <div v-if="isLogin == 1">
            <el-form-item prop="user_contact_email" class="form-item" v-if="form.register_type == 1">
              <el-input v-model="form.user_contact_email" :placeholder="$t('请输入邮箱')"></el-input>
            </el-form-item>
            <!-- 邮箱 -->
            <el-form-item prop="user_contact_mobile" class="form-item" v-if="form.register_type == 2">
              <el-input v-model="form.user_contact_mobile" :placeholder="$t('请输入手机号')"></el-input>
            </el-form-item>
          </div>
          <div v-else>
            <el-form-item prop="user_contact_mobile" class="form-item">
              <el-input v-model="form.user_contact_mobile" :placeholder="$t('请输入手机号')"></el-input>
            </el-form-item>
            <el-form-item prop="user_contact_email" class="form-item">
              <el-input v-model="form.user_contact_email" :placeholder="$t('请输入邮箱')"></el-input>
            </el-form-item>
            <!-- 邮箱 -->

          </div>


          <!-- 隐私协议 -->
          <el-form-item class="privacy-box mb-0">
            
            <el-checkbox v-model="form.isAgree">{{ $t('我已阅读并同意') }}</el-checkbox>
            <span class="cup" @click="handleragreement($event, 1)"> {{ $t('隐私声明') }} </span> {{ $t('与') }} <span
              class="cup" @click="handleragreement($event, 2)"> {{ $t('用户注册协议') }}</span>
          </el-form-item>




        </el-form>

      </div>
      <!-- 登录按钮 -->

      <el-button type="primary" class="w-full sub-btn" @click="handleSubmit" :loading="isSubmitting">{{ $t('确认')
      }}</el-button>

    </div>

    <!-- 隐私协议 -->
    <el-dialog :title="activityInfo.privacyPro.tsap_title" :visible.sync="privacyVisible" width="55%">
      <div class="dialog-content">
        <span v-html="activityInfo.privacyPro.tsap_content"></span>
      </div>

    </el-dialog>

    <el-dialog :title="activityInfo.registerPro.tsap_title" :visible.sync="registerVisible" width="55%">
      <div class="dialog-content">
        <span v-html="activityInfo.registerPro.tsap_content"></span>
      </div>
    </el-dialog>

    <verify ref="verifyModal" @success="verifySuccess" />


  </div>
</template>

<script>
import Cookies from 'js-cookie';
import verify from "../login/components/verify.vue";
import {
  activityLoginInfo,
  activitySignUpLogin,
  activitySignUpRegisters,
  getSmsCaptchaNew,
  getEmailCodeNew,
  getDistrict,
  isCheckCode,
  activitySignUpReLoginEdit
} from "@api/user";
export default {
  components: {
    verify
  },
  data() {
    return {


      // 图形验证
      isNew: true,

      aes_key: 'ed8222',
      aes_script: '8NONwyJt',

      currentLang:localStorage.getItem('currentLanguage'),


      titleType: 1,

      loading: true,
      isSubmitting: false,
      // 隐私协议
      privacyVisible: false,
      registerVisible: false,


      Searchcountry: "",
      Searchprovince: "",



      form: {
        ta_id: 0,
        sign_type: 1,
        register_type: 1,
        user_name: '',
        user_nick_name: '',
        // 地区
        register_country: '',
        // 省份
        register_province: '',
        // 邮箱
        user_email: '',
        user_mobile: '',
        user_mobile_area_code: 86,
        user_mobile_pre_id: '',
        // 验证码
        code: '',
        // 密码
        user_pwd: '',
        user_industry: '',
        // 公司名称
        user_company: '',
        // 职位
        user_job: '',
        // 角色
        user_role: [],
        // 手机号
        user_contact_mobile: '',
        user_contact_email: '',
        isAgree: false,
        sign_from: 'PC',
        user_id: ''
      },

      // 倒计时
      countdown: 60,
      // 倒计时定时器
      countdownTimer: null,
      // 是否显示倒计时
      showCountdown: false,


      // 邮箱倒计时
      countdownEmail: 60,
      // 邮箱倒计时定时器
      countdownEmailTimer: null,
      // 是否显示邮箱倒计时
      showCountdownEmail: false,

      rules: {
        user_name: [
          { required: true, message: this.$t('请输入姓名'), trigger: 'blur' },
        ],
        user_nick_name: [
          { required: false, message: this.$t('请输入昵称'), trigger: 'blur' },
        ],
        user_mobile_area_code: [
          { required: true, message: this.$t('请输入区号'), trigger: 'blur' },
        ],
        user_email: [
          { required: true, message: this.$t('请输入邮箱'), trigger: 'blur' },
        ],
        user_mobile: [
          { required: true, message: this.$t('请输入手机号'), trigger: 'blur' },
        ],
        code: [
          { required: true, message: this.$t('请输入验证码'), trigger: 'blur' }
        ],
        user_pwd: [
          { required: true, message: this.$t('请输入密码'), trigger: 'blur' },
        ],
        user_industry: [
          { required: true, message: this.$t('请选择行业'), trigger: 'change' },
        ],
        user_company: [
          { required: true, message: this.$t('请输入公司名称'), trigger: 'blur' }
        ],
        user_job: [
          { required: true, message: this.$t('请选择职位'), trigger: 'change' }
        ],
        user_role: [
          { type: 'array', required: true, message: this.$t('请选择角色'), trigger: 'change' }
        ],
        user_contact_mobile: [
          { required: true, message: this.$t('请输入电话'), trigger: 'blur' },
        ],
        user_contact_email: [
          { required: true, message: this.$t('请输入邮箱'), trigger: 'blur' },
        ],
        register_country: [
          { required: false, message: this.$t('请选择国家/区域'), trigger: 'change' }
        ],
        // register_province: [
        //   { required: true, message: this.$t('请选择所在省份/州'), trigger: 'change' }
        // ],
      },

      // 隐私协议
      activityInfo: {
        "register_type": 1,
        "privacyPro": {
          "tsap_title": " 华为技术网站隐私协议",
          "tsap_content": "",
        },
        "registerPro": {
          "tsap_title": " 华为公司用户注册协议",
          "tsap_content": "",
        },
      },
      jobList: [],
      register_country: [],
      register_province: [],
      roleList: [],
      industryList: [],

      // 获取当前语言
      language: this.$i18n.locale,
      thisUserInfo: [],
      disabledMobileEmail: false,
      isLogin: 1,
      disabledExpert: false,
    }
  },
  computed: {
    ta_id() {
      return this.$route.params.ta_id
    },
    sign_type() {
      return this.$route.params.sign_type
    },
    view_type() {
      return this.$route.params.view_type
    },
  },
  mounted() {
    this.activityLoginInfo();
    //setTimeout(()=>{
    this.signFeedBack();
    //},100)
    clearInterval(this.countdownTimer);
  },
  methods: {

    // 验证码验证成功
    verifySuccess() {
      this.getCode();
      
    },
    signFeedBack() {
      this.thisUserInfo = JSON.parse(localStorage.getItem('userinfo'))
      //console.log(this.thisUserInfo)
      if (this.thisUserInfo.user_id !== undefined || this.thisUserInfo.user_id > 1) {
        this.handlerCountry();
        this.user_id = this.thisUserInfo.user_id;
        this.form.user_id = this.thisUserInfo.user_id
        this.form.user_mobile = this.thisUserInfo.user_mobile
        this.form.user_email = this.thisUserInfo.user_email
        this.form.user_name = this.thisUserInfo.user_name
        this.form.user_nick_name = this.thisUserInfo.user_nick_name
        this.form.user_contact_mobile = this.thisUserInfo.user_contact_mobile
        this.form.user_contact_email = this.thisUserInfo.user_contact_email
        this.form.register_country = (this.thisUserInfo.register_country == 0) ? '' : this.thisUserInfo.register_country;
        this.form.register_province = (this.thisUserInfo.register_province == 0) ? '' : this.thisUserInfo.register_province;
        this.form.user_company = this.thisUserInfo.user_company
        this.form.user_job = (this.thisUserInfo.user_job == '') ? '' : parseInt(this.thisUserInfo.user_job);
        this.form.user_industry = (this.thisUserInfo.user_industry == '' || this.thisUserInfo.user_industry == null || this.thisUserInfo.user_industry == 10) ? '' : parseInt(this.thisUserInfo.user_industry);
        this.form.user_role = (this.thisUserInfo.user_role == '' || this.thisUserInfo.user_role == null) ? '' : this.thisUserInfo.user_role.replace(/^,|,$/g, '').split(',').map(role => parseInt(role, 10));
        this.disabledMobileEmail = true
        this.isLogin = 2
        if (this.thisUserInfo.user_expert == 10) {
          this.disabledExpert = true
        }
        setTimeout(() => {
          this.loading = false;
        }, 500)
      } else {
        this.loading = false;
      }
    },
    dropDownSearchcountry() {
      const result = this.register_country.filter(item => item.label.includes(this.Searchcountry));
      return result;
    },

    dropDownSearchprovince() {
      const result = this.register_province.filter(item => item.label.includes(this.Searchprovince));
      return result;
    },


    async handleSubmit() {

      // console.log(this.$route.query.callback)
      // return false
      this.rules.register_country[0].required = true;
      if (!this.form.isAgree) {
        return this.$message.error(this.$t('请先同意相关协议'));
      }
      let res
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          if (this.isSubmitting) return;
          this.isSubmitting = true;
          this.form.user_mobile_pre_id = this.form.user_mobile_area_code
          this.form.isLogin = this.isLogin
          //去注册报名登录
          if (this.form.user_id == '') {
            res = await activitySignUpRegisters(this.form);
          } else {
            //修改个人信息，并报名登录
            res = await activitySignUpReLoginEdit(this.form);
          }
       
          if (res.status == 200) {
            this.$message.success(res.msg);
            setTimeout(() => {
			 // 如果是签到成功且有抽奖活动则跳转到抽奖页面
			 if(res.data.is_signed == 10 && res.data.tre_ep !== 0){
				if (this.form.user_id == '') {
					Cookies.set('accessToken',res.data.token);
				}
				return this.$navigate('/rafflelandingpage??tre_ep=' + res.data.tre_ep + '&trer_source_type=20&trer_source_id='+this.ta_id, null, false);
			 } else {
				// 其他情况都跳转到回调地址或首页
				this.$router.push({
				  path: this.$route.query.callback || '/',
				});
			 }
             
              this.isSubmitting = false;
            }, 2000);
          } else {
            this.isSubmitting = false;
          }
        }
      });
    },

    // 手机邮箱切换
    handleSignTypeChange(val) {
      if(val=='2'){
        this.form.isAgree=false;
      }
      //this.$refs.form.clearValidate(["user_mobile","user_email","code","user_mobile_area_code","user_industry","user_company","user_job","user_role","user_contact_mobile","user_contact_email","user_nick_name"]); // 重置指定字段的验证
      if (this.isLogin == 2) {
        this.signFeedBack();
      } else {
        this.$refs.form.resetFields();
        this.form.user_role = '';
        this.form.user_job = '';
        this.form.user_mobile = '';
        this.form.user_email = '';
        this.form.user_mobile_area_code = '86';
      }

      //this.form.sign_type = val;

      // // 清空定时器
      // this.showCountdown = false;
      // this.countdown = 60;
      // clearInterval(this.countdownTimer);
      this.form.register_type = val;
      this.$forceUpdate()

    },


    // 隐私协议
    handleragreement(event, type) {
      event.stopPropagation();
      if (type == 1) {
        this.privacyVisible = true;
      } else if (type == 2) {
        this.registerVisible = true;
      }
    },
    getCode() {
      if (this.form.register_type == 1) {
        // 手机号注册
        if (!this.form.user_mobile) {
          this.$message.warning(this.$t('请输入手机号'));
          return;
        }
        // 如果有区号，调用发送短信验证码的接口
        this.sendCode(this.form.user_mobile, 1, 'regis_', this.form.user_mobile_area_code);
      } else {
        // 邮箱注册
        if (!this.form.user_email) {
          this.$message.warning(this.$t('请输入邮箱'));
          return;
        }
        let emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(this.form.user_email)) {
          this.$message.warning(this.$t('请输入正确的邮箱'));
          return;
        }
        // 如果邮箱有效，调用发送邮件验证码的接口
        this.sendCode(this.form.user_email, 2, 'regis_');
      }
    },
    // 发送验证码
    async sendCode(numberStr, type, px, areacode = '') {
      let data = { px: px };
      let response;

      // 根据类型选择不同的接口
      if (type === 1) {
        data.phone = numberStr;
        data.areacode = areacode;
        try {

          // let 
          // isNew

          data.phone = this.isNew ? this.$encryptByAES(data.phone, this.aes_key, this.aes_script) : data.phone;
          data.type = 1;
          let codeRes = await getSmsCaptchaNew(data);

          if (codeRes.status == '400C1' && this.isNew) {
            this.$refs.verifyModal.openModal(data.phone);
            return false;
          }
          //  验证成功后 
          this.startCountdownMobile();
           //this.generateCaptcha();
        } catch (error) {
          return;
        }
      } else {
        data.email = numberStr;
        try {
          response = await getEmailCodeNew(data);
        } catch (error) {
          return;
        }
      }

      // 处理响应结果
      if (response.status === 200) {
        // this.$message.success(type === 1 ? '手机验证码发送成功' : '邮件验证码发送成功');
          this.startCountdownEmail();

      } else {
        // this.$message.error(response.msg || '验证码发送失败');
      }
    },
    //获取随机验证码
    /*generateCaptcha() {
      this.startCountdownMobile();
      setTimeout(() => {
        let captcha = '';
        for (let i = 0; i < 6; i++) {
          captcha += Math.floor(Math.random() * 10); // 随机生成一个数字
        }
        this.form.code = captcha;// 更新验证码
        this.handleBlur();
      }, 2000);
    },*/
    startCountdownMobile() {
      this.showCountdown = true;
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.showCountdown = false;
          this.countdown = 60;
          clearInterval(this.countdownTimer);
        }
      }, 1000);
    },
    startCountdownEmail() {
      this.showCountdownEmail = true;
      this.countdownEmailTimer = setInterval(() => {
        this.countdownEmail--;
        if (this.countdownEmail <= 0) {
          this.showCountdownEmail = false;
          this.countdownEmail = 60;
          clearInterval(this.countdownEmailTimer);
        }
      }, 1000);
    },
    // 开启倒计时
    startCountdown() {
      this.isButtonDisabled = true;  // 禁用按钮
      let timer = setInterval(() => {
        if (this.countdown === 0) {
          clearInterval(timer);
          this.isButtonDisabled = false;  // 启用按钮
          this.countdown = 60;
        } else {
          this.countdown--;
        }
      }, 1000);
    },
    async handleBlur() {
      if (this.form.code.length === 6 || this.form.code.length === 8) {
        // 验证码输入完成，执行查询用户信息的操作
        const userData = await isCheckCode({
          mobile: this.form.user_mobile,
          email: this.form.user_email,
          yzmCode: this.form.code,
          areacode: this.areacode,
          register_type: this.form.register_type
        });
        if (userData.status == 200) {
          if (userData.data.user_id != '') {
            this.handlerCountry();
            this.user_id = userData.data.user_id;
            this.form.user_id = userData.data.user_id
            this.form.user_mobile = userData.data.user_mobile
            this.form.user_email = userData.data.user_email
            this.form.user_name = userData.data.user_name
            this.form.user_nick_name = userData.data.user_nick_name
            this.form.user_contact_mobile = userData.data.user_contact_mobile
            this.form.user_contact_email = userData.data.user_contact_email
            this.form.register_country = (userData.data.register_country == 0) ? '' : userData.data.register_country;
            this.form.register_province = (userData.data.register_province == 0) ? '' : userData.data.register_province;
            this.form.user_company = userData.data.user_company
            this.form.user_job = (userData.data.user_job == '') ? '' : parseInt(userData.data.user_job);
            this.form.user_industry = (userData.data.user_industry == '' || userData.data.user_industry == null || userData.data.user_industry == 10) ? '' : parseInt(userData.data.user_industry);
            //this.form.user_role = userData.data.user_role.replace(/^,|,$/g, '').split(',').map(role => parseInt(role, 10));
            this.form.user_role = (userData.data.user_role == '' || userData.data.user_role == null) ? '' : userData.data.user_role.replace(/^,|,$/g, '').split(',').map(role => parseInt(role, 10));
            if (userData.data.user_expert == 10) {
              this.disabledExpert = true
            }
            setTimeout(() => {
              this.loading = false;
            }, 1000)
          }
          else {
            this.user_id = ''
            this.form.user_id = ''
            this.form.user_name = ''
            this.form.user_nick_name = ''
            this.form.user_contact_mobile = ''
            this.form.user_contact_email = ''
            this.form.register_country = ''
            this.form.register_province = ''
            this.form.user_company = ''
            this.form.user_job = ''
            this.form.user_industry = ''
            this.form.user_role = ''

          }
          this.loading = false;
          this.$refs.form.clearValidate();
        }
      }
    },
    handlerCountry() {
      // 更改洲后清空后续选项
      this.form.register_province = '';
      // 获取新的国家列表
      setTimeout(() => {
        this.getcitytArea(this.form.register_country);
      }, 100);
      
    },
    async getcitytArea(value) {
      let res = await getDistrict(3, value);
      if (res.status == 200) {
        this.register_province = res.data;
      }
    },
    async activityLoginInfo() {
      // 优化一进去选中默认验证状态，方式请求接口后闪屏一下
      this.form.register_type = this.language == 'en' ? 2 : 1;
      this.handleSignTypeChange(this.language == 'en' ? 2 : 1)

      const res = await activityLoginInfo({
        ta_id: this.ta_id,
        sign_type: this.sign_type,
        type: this.view_type,
      });
      if (res.status == 200) {
        this.activityInfo = res.data;
        this.jobList = res.data.user_job_options;
        this.register_country = res.data.country_list;
        this.roleList = res.data.user_role_options;
        this.industryList = res.data.user_industry_options;
        this.form.ta_id = this.ta_id;
        //this.form.sign_type = this.sign_type;
        this.form.register_type = res.data.register_type;
        this.register_type = res.data.register_type;
        this.handleSignTypeChange(this.register_type)
      }
    },
    // 隐私协议
    handleragreement(event, type) {
      event.stopPropagation();
      if (type == 1) {
        this.privacyVisible = true;
      } else if (type == 2) {
        this.registerVisible = true;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.search_input {
  min-height: 40px !important;
  height: fit-content;
  margin-top: 8px;
  background-color: #ffffff;

  ::v-deep() {
    .el-input__inner {
      border: 1px solid #808080;
    }

  }
}

::v-deep() {
  .el-dialog__body {
    max-height: calc(70vh - 54px);
    margin-bottom: 24px;
    padding: 24px 0;

    // overflow-y: scroll;
    .dialog-content {
      width: 100%;
      max-height: calc(70vh - 102px);
      padding: 0 24px;
      overflow: hidden;
      overflow-y: scroll;

      // 设置滚动条样式
      &::-webkit-scrollbar {
        width: 4px;
        height: 8px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: #B7251E;
      }
    }
  }

  .areacode-ipt {
    .el-input__inner {
      padding: 0;
    }
  }
}

.privacy-box {

  ::v-deep() {



    // 多选框变圆形
    .el-checkbox__inner {
      width: 18px;
      height: 18px;
      border-radius: 50%;
    }

    .el-checkbox__inner::after {
      left: 6px;
      top: 3px;
    }

    .el-form-item__content,
    .el-checkbox__label {
      font-size: 12px !important;
      font-weight: 400;
      line-height: 18px;
      color: #AEAEAE;
    }
  }

  span {
    font-size: 12px !important;
    color: #B7251E;
  }
}

.sub-btn {
  border-radius: 20px;
  height: 40px;
  background: rgb(183, 37, 30);
}

.type-item {
  ::v-deep() {
    .el-form-item__content {
      height: 20px;
      display: flex;
    }
  }
}

.phone-item {
  ::v-deep() {
    .el-input__suffix {
      display: none;
    }

    .el-input--suffix .el-input__inner,
    .el-input__inner {
      border: none;
      border-radius: 8px;
      background: rgb(245, 248, 255);
    }
  }
}

::v-deep() {
  .el-form-item__error {
    padding-top: 0;
  }
}

.signregist-box {
  width: calc(100% + 60px);
  padding-right: 60px;
  overflow: hidden;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 4px;
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #B7251E; 
  }

}

::v-deep() {
  .el-form-item {
    margin-bottom: 16px;
  }
}

.form-item {
  min-height: 40px;
  border-radius: 4px;
  background: rgb(245, 248, 255);

  ::v-deep() {
    .el-input__inner {
      height: 40px;
      border: none;
      background: transparent
    }
  }
}

.signregist-container {
  width: 100%;
  height: 100vh;
  background: url('../../assets/images/login-bg.png') no-repeat left bottom;
  background-size: cover;
  background-color: #f5f8ff;

  .login-logo {
    position: absolute;
    left: 40px;
    top: 40px;
  }

  .login-textimg {
    width: 44.43%;
    position: absolute;
    left: 120px;
    top: 30%;
  }


  .signregist-content {
    width: 520px;
    height: 918px;
    max-height: calc(100vh - 119px);
    border-radius: 16px;
    box-shadow: 0px 8px 24px 8px rgba(28, 57, 123, 0.08);
    background: rgb(255, 255, 255);
    position: absolute;
    right: 120px;
    top: 50%;
    transform: translateY(-50%);
    padding: 60px;

    .title {
      color: rgb(25, 25, 25);
      font-size: 20px;
      line-height: 30px;

      span {
        font-size: 20px;
        line-height: 30px;
        position: relative;
      }

      span.active::after {
        content: "";
        display: inline-block;
        width: 100%;
        height: 2px;
        background: #b7251e;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
  }
}
</style>